export default __webpack_public_path__ + "static/media/A524.bdd05b8c.webp";